import { z } from 'zod';
import { request } from './http';

const cursorSchema = z.object({ eventCursor: z.number().int().nonnegative() });

/**
 * Cursor atual do log de eventos. Serve como "estou autenticado?" (rota protegida: 401 aqui
 * encerra a sessão pelo caminho de sempre) e como ponto de partida do tempo real.
 */
export async function fetchRealtimeCursor(signal?: AbortSignal): Promise<number> {
  const { eventCursor } = await request('/realtime/cursor', {
    schema: cursorSchema,
    ...(signal ? { signal } : {}),
  });
  return eventCursor;
}
